var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slideshow-container"},[_c('div',{staticClass:"slides",style:({
      transform: `translateX(-${_vm.currentIndex * 100}%)`,
      display: 'flex',
    })},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"slide",style:({ width: '100%' })},[_c('img',{staticClass:"slide-image",attrs:{"src":image,"alt":"Segelfliegen Bilder"}})])}),0),_c('button',{staticClass:"nav-button prev",on:{"click":_vm.prev}},[_vm._v("❮")]),_c('button',{staticClass:"nav-button next",on:{"click":_vm.next}},[_vm._v("❯")])])
}
var staticRenderFns = []

export { render, staticRenderFns }